export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img3-e3a720487d34a8e4a488300e5368ad17.png";